var map = {
	"./Event": "ac93",
	"./Event.json": "ac93",
	"./about.md": "c23e",
	"./config": "eba3",
	"./config.json": "eba3",
	"./links": "0b2a",
	"./links.json": "0b2a",
	"./posts": "765a",
	"./posts.json": "765a",
	"./project-des.md": "b2f2",
	"./projects": "cc99",
	"./projects.json": "cc99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d9c";